import { RemoteCollectionStore } from "@softline/core";
import {Absatzplan} from '../types/absatzplan';

export type AbsatzplanVersion = {
  id: number;
  status: Absatzplan['status']
  version: Absatzplan['version'];
}

export const AbsatzplanVersionenStore = RemoteCollectionStore.create<AbsatzplanVersion>();
